import React, { useState, useEffect } from 'react';
import axios from 'axios'; // Import axios directly
import netlifyIdentity from 'netlify-identity-widget';
import quotes from '../quotes.json'; // Import quotes

const Home = ({ onFetchSuccess }) => {
    const [input, setInput] = useState("");
    const [breakPreference, setBreakPreference] = useState("frequentShortBreaks");
    const [isLoading, setIsLoading] = useState(false);
    const [charsLeft, setCharsLeft] = useState(1000);
    
    const [currentQuote, setCurrentQuote] = useState(quotes.quotes[0]);
    const [loadingDots, setLoadingDots] = useState('.');

    useEffect(() => {
        netlifyIdentity.init();

        const quoteInterval = setInterval(() => {
            setCurrentQuote(quotes.quotes[Math.floor(Math.random() * quotes.quotes.length)]);
        }, 6000);

        const loadingDotsInterval = setInterval(() => {
            setLoadingDots(prevDots => prevDots.length < 3 ? prevDots + '.' : '.');
        }, 500);

        return () => {
            clearInterval(quoteInterval);
            clearInterval(loadingDotsInterval);
        };
    }, []);

    const handleInputChange = (e) => {
        setInput(e.target.value);
        setCharsLeft(1000 - e.target.value.length);
    }

    const handleSubmit = async () => {
        console.log("Submitting...");   
        const user = netlifyIdentity.currentUser();
        if (!user) {
            alert("You need to be logged in to submit.");
            return;
        }

        setIsLoading(true);
        const breakMessage = breakPreference === "frequentShortBreaks" ? " Please include frequent 5 minute breaks." :
                             breakPreference === "infrequentShortBreaks" ? " Please include infrequent 5 minute breaks." :
                             breakPreference === "infrequentLongBreaks" ? " Please include infrequent 15 minute breaks." : "";

        try {
            const response = await axios.post('/.netlify/functions/chatgpt', { input: input + breakMessage }, {
                headers: {
                    'Authorization': `Bearer ${user.token.access_token}`
                }
            });
            onFetchSuccess(response.data);
            setIsLoading(false);
        } catch (error) {
            console.error(error);
            console.error("Error during submission:", error);
            setIsLoading(false);
            alert('An error occurred. Please refresh the page and try again.');
        }
    }

    return (
        <div className="home">
            <div className="home-container">
                <h2>Let's get stuff done.</h2>
                {isLoading ? (
                    <>
                        <p>Creating schedule. This may take a moment{loadingDots}</p>
                        <div className="quote-container" key={currentQuote.Quote}>
                            <p>"{currentQuote.Quote}"</p>
                            <p className="quote-author">- {currentQuote.Author}</p>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="input-container">
                            <textarea 
                                className="input-field"
                                value={input}
                                onChange={handleInputChange}
                                onInput={(e) => {
                                    e.target.style.height = 'auto';
                                    e.target.style.height = `${e.target.scrollHeight}px`; // Auto-expand
                                }}
                                placeholder="Example: For the next 2.5 hours I plan to work on studying for my exam. My main areas of focus are..."
                                maxLength={1000}
                            />
                            <p className="text-muted text-italic">{charsLeft} Characters remaining</p>
                        </div>
                        <div className="select-container">
                            <select 
                                className="select-field"
                                name="breakPreference"
                                value={breakPreference}
                                onChange={(e) => setBreakPreference(e.target.value)}
                            >
                                <option value="frequentShortBreaks">Frequent Short Breaks</option>
                                <option value="infrequentShortBreaks">Infrequent Short Breaks</option>
                                <option value="infrequentLongBreaks">Infrequent Long Breaks</option>
                            </select>
                        </div>
                        <button className="submit-button" onClick={handleSubmit}>Submit</button>
                    </>
                )}
            </div>
        </div>
    );
}

export default Home;